// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createAction } from "@reduxjs/toolkit";
import { persistor } from "./store";
import { logoutLocalUser } from "./user/userActions";
import { authContextRef } from "../../web-utils/src/context/authContextRef";

import { clearError as clearCompaniesErrors } from "./companies/companiesSlice";
import { clearError as clearEquipmentErrors } from "./equipment/equipmentSlice";
import { clearError as clearScenesErrors } from "./scenes/scenesSlice";
import { clearError as clearScriptsErrors } from "./scripts/scriptsSlices";
import { clearError as clearShowsErrors } from "./shows/showsSlice";
import { clearError as clearStudioErrors } from "./studio/studioSlice";
import { clearError as clearUserErrors } from "./user/userSlice";

export const appLogoutReset = createAction("app/logoutReset");

export const logout =
  (isLocalUser = false) =>
  async (dispatch, getState) => {
    if (isLocalUser) {
      const state = getState();
      const username =
        state?.user?.user?.username || state?.user?.user?.oauth_uid;
      await dispatch(logoutLocalUser({ username }));
    }

    authContextRef.current?.logout();
    await persistor.purge();
    dispatch(appLogoutReset());
  };

export const clearAllErrors = () => (dispatch) => {
  dispatch(clearCompaniesErrors());
  dispatch(clearEquipmentErrors());
  dispatch(clearScenesErrors());
  dispatch(clearScriptsErrors());
  dispatch(clearShowsErrors());
  dispatch(clearStudioErrors());
  dispatch(clearUserErrors());
};
